import React, {useState, useEffect, useRef} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Link } from 'react-router-dom';
import { Row, Col, Container, Card, CardBody, CardTitle, Modal, Form, Label, Input, Badge, UncontrolledDropdown } from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import axios from 'axios';
import * as url from 'helpers/url_helper';
import { Config, TOAST_OPTIONS, formatDate } from 'helpers/backend_helper';
import toastr from "toastr";
import "toastr/build/toastr.min.css";

import { Button,  DropdownToggle,  DropdownMenu,  DropdownItem,  ButtonDropdown, Table} from "reactstrap";
import LoadingOverlay from 'react-loading-overlay';
import BounceLoader from 'react-spinners/BounceLoader'
import Select from "react-select"

import ToolkitProvider, {Search} from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
//import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';

import paginationFactory, {
    PaginationListStandalone,
    PaginationProvider,
  } from "react-bootstrap-table2-paginator";

  import "flatpickr/dist/themes/material_blue.css";
  import Flatpickr from "react-flatpickr";



    const CallCenterReport = () => {

        toastr.options = TOAST_OPTIONS;
        const [modal_complaint, setmodal_complaint] = useState(false);
        const [isEdit, setIsEdit] = useState(false);
        const [complaints, setComplaints] = useState([])
        const [categories, setCategories] = useState([])
        const [isLoading, setIsLoading] = useState(false)

        const [id, setId] = useState('')
        const [refno, setRefNo] = useState('')
        const [name, setName] = useState('')
        const [phone, setPhone] = useState('25263')
        const [email, setEmail] = useState('')
        const [account, setAccount] = useState('')
        const [address, setAddress] = useState('')
        const [area, setArea] = useState('')
        const [category, setCategory] = useState('')
        const [details, setDetails] = useState('')
        const [status, setStatus] = useState('')
        const [handlerDept, setHandlerDept] = useState('')
        const [assigns, setAssigns] = useState([])
        const [deptList, setDeptList] = useState([])
        const [handler, setHandler] = useState('')
        const [dateTimeAssigned, setDateTimeAssigned] = useState('')
        const [dateTimeRegistered, setDateTimeRegistered] = useState('')
        const [languages, setlanguages] = useState([])
        const [lang, setLang] = useState('Somali')
        const [areas, setAreas] = useState([])

        
        const [statusOptions, setStatusOptions] = useState(['Open', 'Assigned', 'Closed'])


        const [closedOn, setClosedOn] = useState('')
        const [workDone, setWorkDone] = useState('')
        const [recommendations, setRecommendations] = useState('')
        const [responseTime, setResponseTime] = useState('')
        const [correctionTime, setCorrectionTime] = useState('')

        const [sDate, setSDate]         = useState([new Date()])
        const [eDate, setEDate]         = useState([new Date()])
        const [sArea, setSArea]         = useState('')
        const [sStatus, setSStatus]     = useState('')
        const [sCategory, setSCategory] = useState('')
        const [sRefNo, setSRefNo]       = useState('')
        const [sStaff, setSStaff]       = useState('')
        
        const removeBodyCss = () => {
          document.body.classList.add("no_padding");
        }
 
        const tog_complaint = () => {
          fetchData()
          setmodal_complaint(!modal_complaint)
          removeBodyCss()
        }

        const fetchData = () => {

          axios.get(url.COMPLAINTCATEGORIES, Config).then((r)=>{ 
            setCategories(r.data)
          }).catch((e)=>{  
            console.log(e)
          });
          axios.get(`${url.USERS}`, Config).then((r)=>{ 
            setAssigns(r.data)
          }).catch((e)=>{  
            console.log(e);
          });
          axios.get(`${url.TERRITORIES}`, Config).then((r)=>{ 
            setAreas(r.data);
          }).catch((e)=>{  
            console.log(e);
          });
          axios.get(`${url.MESSAGES}`, Config).then((r)=>{
            setlanguages(r.data)
          }).catch((e)=>{
            console.log(e)
          })
          axios.get(url.DEPTS, Config).then((r)=>{ setDeptList(r.data)}).catch((e)=>console.log(e))
        }
        
        useEffect(() => {
          fetchData();
        },[]);

        const handleExport = () =>{
          const data = {
            refno     : sRefNo,
            area      : sArea,
            category  : sCategory,
            status    : sStatus,
            staff     : sStaff,
            startDate : formatDate(sDate),
            endDate   : formatDate(eDate),
          }
          setIsLoading(true)
          axios.post(`${url.COMPLAINTREPORT}`, JSON.stringify(data), Config).then((r)=>{ 
            setComplaints(r.data)
            const urlx = url.APACHE_URL + "attach/output.xlsx"
            axios({
              url: urlx,
              method: 'GET',
              responseType: 'blob',
            })
            .then((response) => {
               const url = window.URL.createObjectURL(new Blob([response.data]));
               const link = document.createElement('a');
               link.href = url;
               link.setAttribute('download', `Complaints-Report.xlsx`);
               document.body.appendChild(link);
               link.click();
               document.body.removeChild(link);
               window.URL.revokeObjectURL(url);
             })
             .catch((error) => {
               console.error('Error downloading the file:', error);
             });
            setIsLoading(false)
          }).catch((e)=>{  
            console.log(e); 
            setIsLoading(false)
          });
        }
        const handleFilterData = () =>{
          const data = {
            refno     : sRefNo,
            area      : sArea,
            category  : sCategory,
            status    : sStatus,
            staff     : sStaff,
            startDate : formatDate(sDate),
            endDate   : formatDate(eDate),
          }
          setIsLoading(true)
          axios.post(`${url.COMPLAINTFILTER}`, JSON.stringify(data), Config).then((r)=>{ 
            setComplaints(r.data)
            setIsLoading(false)
          }).catch((e)=>{  
            console.log(e); 
            setIsLoading(false)
          });
        }
        const handleClearSearch = () =>{
          setSRefNo('')
          setSArea('')
          setSCategory('')
          setSStatus('')
          setSStaff('')
          setSDate(new Date())
          setEDate(new Date())
          handleFilterData()
        }
        const handleClickAdd = () =>{
            setIsEdit(false)
            clearData()
            tog_complaint()
        }

        const pageOptions = {
          sizePerPage: 200,
          totalSize: complaints.length, // replace later with size(orders),
          custom: true,
        }
        var node = useRef();
              

        const { SearchBar } = Search;
        const columns = [

        {
          dataField: 'dateTime',
          text: 'Date and Time',
          sort: true
        },
        {
          dataField: 'name',
          text: 'Name',
          sort: true
        },
        {
          dataField: 'refno',
          text: 'Reference',
          sort: true
        }, 

        {
          dataField: 'account',
          text: 'Acc No',
          sort: true
        }, 
        {
          dataField: 'phone',
          text: 'Phone No',
          sort: true
        }, 
        {
          dataField: 'type',
          text: 'Type',
          sort: true
        }, 
        {
          dataField: 'staff',
          text: 'Staff',
          sort: true
        }, 
        {
          dataField: 'status',
          text: 'Status',
          sort: true,
          formatter: statusFormatter
        }];

        const defaultSorted = [{
          dataField: 'dateTime',
          order: 'desc'
        }];

        function statusFormatter(cellContent, row) {
          if (row.status == "Open") {
            return (
              <div>
                  <Badge className="me-2 bg-danger">{ cellContent }</Badge>
              </div>
            );
          }else if(row.status == "Assigned"){
            return (
              <div>
                  <Badge className="me-2 bg-warning">{cellContent}</Badge>
              </div>
            );
          }else{
            return (
              <div>
                  <Badge className="me-2 bg-success">{ cellContent }</Badge>
              </div>
            );
          }
        }

        
        return (
            <>
              <LoadingOverlay
                active={isLoading}
                spinner={<BounceLoader />}
                text='Please wait...'
                >
                <div className="page-content">
                    <MetaTags>
                    <title>Complaints report | {url.COMPANY}</title>
                    </MetaTags>
                    <Container fluid={true}>
                        <Row>
                                      
                            <Col lg="12">
                            <Card>
                            <h5 className="card-header bg-transparent border-bottom text-uppercase">Report Parameters</h5>
                                <CardBody>
                                <div>
                                    <Row className="mb-3">
                                    <Col xl={6} sm={6}>
                                        <div className="mt-2">
                                        <h5>{``}</h5>
                                        </div>
                                    </Col>

                                

                                    
                                    </Row>
                                </div>
                                
                  
                                

                                                
                                                <Row className="justify-content-center mb-2">
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>From</label>
                                                          <Flatpickr
                                                            className="form-control form-control-sm"
                                                            options={{
                                                                dateFormat: "Y-m-d",
                                                                enableTime: false
                                                            }}
                                                            value={sDate}
                                                            onChange={(dates)=>setSDate(dates)}
                                                            />
                                                      </div>
                                                  </Col>
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Till </label>
                                                          <Flatpickr
                                                              className="form-control form-control-sm"
                                                              options={{
                                                                  dateFormat: "Y-m-d",
                                                                  enableTime: false
                                                              }}
                                                              value={eDate}
                                                              onChange={(dates)=>setEDate(dates)}
                                                              />
                                                      </div>
                                                  </Col>
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Status</label>
                                                          <select className="form-select form-select-sm" value={sStatus} onChange={(e)=>setSStatus(e.target.value)}>
                                                          <option value=""></option>
                                                              {statusOptions.map((s,k)=>(
                                                                  <option value={s} key={k}>{s}</option>
                                                              ))}
                                                          </select>
                                                      </div>
                                                  </Col>
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>District</label>
                                                          <select className="form-select form-select-sm" value={sArea} onChange={(e)=>setSArea(e.target.value)}>
                                                          <option value=""></option>
                                                              {areas.map((c,k)=>(
                                                                  <option value={c.id} key={k}>{c.name}</option>
                                                              ))}
                                                          </select>
                                                      </div>
                                                  </Col>
                                                
                                                  
                            
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Category</label>
                                                          <select className="form-select form-select-sm" value={sCategory} onChange={(e)=>setSCategory(e.target.value)}>
                                                              <option value=""></option>
                                                              {categories.map((c,k)=>(
                                                                  <option value={c.id} key={k}>{c.name}</option>
                                                              ))}
                                                          </select>
                                                      </div>
                                                  </Col>
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Staff</label>
                                                          <select className="form-select form-select-sm" value={sStaff} onChange={(e)=>setSStaff(e.target.value)}>
                                                              <option value=""></option>
                                                              {assigns.map((c,k)=>(
                                                                  <option value={c.id} key={k}>{c.name}</option>
                                                              ))}
                                                          </select>
                                                      </div>
                                                  </Col>
                                                  
                                                </Row>
                                                <Row  className="justify-content-center mb-2">
                                                <Col lg={2} className='mb-2'> 
                                                  <div className="d-grid gap-2">
                                                      <Button
                                                        color='danger'
                                                        className="btn btn-sm"
                                                        onClick={()=>{handleFilterData()}}
                                                      >
                                                        <i className="mdi mdi-magnify me-1" />
                                                        Get Data
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                  <Col lg={2} className='mb-2'> 
                                                  <div className="d-grid gap-2">
                                                      <Button
                                                        color='primary'
                                                        className="btn btn-sm"
                                                        onClick={()=>{handleExport()}}
                                                      >
                                                        <i className="mdi mdi-export me-1" />
                                                        Export to Excel
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                  <Col lg={2} className='mb-2'> 
                                                  <div className="d-grid gap-2">
                                                      <Button
                                                        color='warning'
                                                        className="btn btn-sm"
                                                        onClick={()=>{handleClearSearch()}}
                                                      >
                                                        <i className="mdi mdi-notification-clear-all me-1" />
                                                        Reset
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                  
                                                </Row>
                                                </CardBody>
                                                </Card>
                                                <Card>
                                                <h5 className="card-header bg-transparent border-bottom text-uppercase">Data</h5>
                                                  <CardBody>

                                                  
                                            
                                {(complaints.length > 0) && (

                                    <PaginationProvider
                                    pagination={paginationFactory(pageOptions)}
                                    keyField="id"
                                    columns={columns}
                                    data={complaints}
                                    >
                                    {({ paginationProps, paginationTableProps }) => (
                                    <ToolkitProvider
                                      keyField="id"
                                      data={ complaints }
                                      columns={ columns }
                                      search
                                    >
                                      { toolkitProps => (
                                          <React.Fragment>
                              
                                            <Row>
                                              <Col xl="12">
                                                
                                            
                                                <BootstrapTable 
                                                  keyField='id' 
                                                  data={ complaints } 
                                                  columns={ columns } 
                                                  striped
                                                  hover
                                                  condensed
                                                  bordered={ false }
                                                  noDataIndication="No Records" 
                                                  defaultSorted={ defaultSorted }
                                                  classes={ "table table-sm align-middle table-nowrap table-check" }
                                                    {...toolkitProps.baseProps}
                                                  //onTableChange={handleTableChange}
                                                    {...paginationTableProps}
                                                  ref={node}
                                                  />
                                            
                                            </Col>
                                            </Row>
                                            <Row className="align-items-md-center mt-30">
                                              <Col className="pagination pagination-rounded justify-content-end mb-2 inner-custom-pagination">
                                                <PaginationListStandalone
                                                  {...paginationProps}
                                                />
                                              </Col>
                                            </Row>
                                            </React.Fragment>
                                            
                                      )
                                    }
                                    </ToolkitProvider>
                                    )}
                                    </PaginationProvider>
                                    )}
                                    {complaints && (complaints.length < 1) && (
                                    <div className="text-center">
                                      <div className="mb-4">
                                      <i className="mdi mdi-flask-empty-minus-outline text-danger display-4" />
                                      </div>
                                      <div>
                                      { isLoading ? <h5>Please Wait...</h5> : <h5>No data found</h5> }
                                      <p className="text-muted">
                                              
                                      </p>
                                      </div>
                                      
                                    </div>
                                    

                                    )}


                                </CardBody>
                            </Card>
                            </Col>

                           
                        </Row>

                        
                           

                    </Container>
                </div>
                </LoadingOverlay>
            </>
        );
    }

export default CallCenterReport;